import React from 'react';
import '../../App.css';

export default function Portfolio() {
    return <h1 className='portfolio' style={{ backgroundImage: `url("images/img-1.jpg")`}}>PORTFOLIO</h1>;
}